export class ComponentContainer {
    keyName: string;
    component: any;
    action: string;
    applicationModuleId: number;
    rootModuleId: number;
    childModuleName: string;
    isPopup?: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/core/component_container.ts